import { render, staticRenderFns } from "./list.vue?vue&type=template&id=a30bc3a2&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=a30bc3a2&prod&scoped=true&lang=less&"
import style1 from "./list.vue?vue&type=style&index=1&id=a30bc3a2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30bc3a2",
  null
  
)

export default component.exports